import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyImgModule } from '@core-mkt/services/lazy-load/lazy-load.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { VisionButtonModule } from '../vision-button/vision-button.module';
import { VisionSelectModule } from '../vision-select/vision-select.module';
import { ProductFormComponent } from './study-plan-builder/product-form/product-form.component';
import { SliderComponent } from './study-plan-builder/slider/slider.component';
import { StudyPlanBuilderComponent } from './study-plan-builder/study-plan-builder.component';
import { WysiwygContentComponent } from './study-plan-builder/wysiwyg-content/wysiwyg-content.component';

@NgModule({
  exports: [SliderComponent, WysiwygContentComponent, ProductFormComponent],
  imports: [
    CommonModule,
    LazyImgModule,
    VisionSelectModule,
    VisionButtonModule,
    FontAwesomeModule,
    StudyPlanBuilderComponent,
    SliderComponent,
    WysiwygContentComponent,
    ProductFormComponent,
  ],
})
export class StudyPlanBuilderModule {}
